/********************************************************************
 * Project: WDCK（2021）
 * Class: MstUserDTO
 * ----------------------------------------
 * <summary>
 * MstUserDTO
 * </summary>
 * <history>
 *      ThaiTV     2022/01/05      Create
 * </history>
 ********************************************************************/
export class MstUserDTO {
    ConsulName: string;
    KanaName: string;
    DateOfBirth: string;
    Gender: string;
    PhoneNum: string;
    PostalCode: string;
    Adress1: string;
    Adress2: string;
    MailAdress: string;
    WebRsvNote: string;
    CountryCode: string;
    /* 20250320 #24407 add start */
    RsvNum: string;
    RsvDate: string;
    RsvTime: string;
    /* 20250320 #24407 add end */
}
